import { cantons, CantonId } from '../../domain/cantons'

export const featureIdCode = (id: number): undefined | CantonId => {
  const cd = cantons.find((x) => x.featureId === id)
  return cd ? cd.cantonId : undefined
}

export const featureCodeId = (code: string): number => {
  const cd = cantons.find((x) => x.cantonId === code)
  return cd ? cd.featureId : -1
}
